export default {
  app: {
    languagePopup: {
      title: 'Je bevindt je momenteel op de Engelse versie van {logo}',
      subtitle: 'Wil je wisselen naar je voorkeurstaal?',
      cta: 'Wissel naar {lang}',
    },
  },
};
